import { Vue, Component, PropSync, Inject } from 'vue-property-decorator'
import { InvoiceStatus, InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { PaymentMethodResponse } from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'
import { billingCommonPaymentMethodService } from '@/api/services/billing/common-payment-method/billing-common-payment-method.service'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'
import { billingCommonAccountingUnitService } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.service'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { Validator } from 'vee-validate'
import {
    BillingModalInvoicesCrudFormState,
    initialBillingModalInvoicesCrudFormState
} from '@/modules/billing-module/components/modal/invoices/crud/components/form/billing-modal-invoices-crud-form.model'

@Component
export default class BillingModalInvoicesCrudForm extends Vue {
    @PropSync('invoice', { type: Object, required: true }) readonly syncedInvoice!: InvoiceResponse

    @Inject() externalValidator!: Validator

    state: BillingModalInvoicesCrudFormState
    constructor() {
        super()
        this.state = initialBillingModalInvoicesCrudFormState()
        this.$validator = this.externalValidator
    }

    get disabledRealTotalValue(): boolean {
        return !this.invoiceGenerated
    }

    get disabledRealAccountingUnit(): boolean {
        return !this.invoiceGenerated
    }

    get invoiceGenerated(): boolean {
        return this.syncedInvoice.status?.code === InvoiceStatus.GENERATED
    }
    get invoiceCancelled(): boolean {
        return this.syncedInvoice.status?.code === InvoiceStatus.CANCELLED
    }
    get invoiceVerified(): boolean {
        return this.syncedInvoice.status?.code === InvoiceStatus.VERIFIED
    }

    get isFieldRequired(): boolean {
        return !!this.syncedInvoice.realTotalValue || !!this.syncedInvoice.realAccountingUnit
    }

    getAccountingUnitLabel(accountingUnit: AccountingUnitResponse): string {
        return `${accountingUnit.name} (${accountingUnit.symbol})`
    }

    async getAllActivePaymentMethods(): Promise<PaymentMethodResponse[]> {
        const response =
            await PromiseUtils.toCallSecure(
                billingCommonPaymentMethodService.getAllActivePaymentMethods())
        return response ?? []
    }

    async getAllActiveUnits(): Promise<AccountingUnitResponse[]> {
        const response =
            await PromiseUtils.toCallSecure(
                billingCommonAccountingUnitService.getAllActiveAccountingUnits())
        return response ?? []
    }

    increaseRealTotalValueKey(): void {
        this.state.realTotalValueKey++
    }
}
